import './index.scss'

const VoidIcon = () => {
    return (
        <article className="voidIcon">
        </article>
    )
}

export default VoidIcon